import { Wording } from '@/types';

export const LOVE_WORDING_DE: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Meditationen',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Anleitungen',
  components_header_text2: 'Der Blog',
  components_header_members: 'Mitglieder',
  hero_text: 'Entdecke die Liebe durch die Sterne',
  hero_button_text: 'Beginnen Sie Ihre Reise',
  components_ressources_section_title: 'LIEBE & ASTROLOGIE',
  components_ressources_subheader_text: 'Ihr himmlisches Toolkit für romantische Einblicke',
  components_ressources_span_text: 'Tauchen Sie ein in unser Universum aus Podcasts und Artikeln rund um Liebe, Sternzeichenkompatibilität und kosmische Verbundenheit. Ob Sie nach Klarheit über Ihre Seelenverwandtschaft suchen oder Ihre Beziehungsmuster entschlüsseln möchten – unsere Ressourcen führen Sie durch die Sterne zu einem tieferen Verständnis.',
  components_ressources_card_1_title: 'Sternzeichen-Liebesgespräche',
  components_ressources_card_1_text: 'Entdecken Sie emotionale Podcast-Episoden, die sich mit der emotionalen Sprache jedes Zeichens, der Liebeskompatibilität, der Leidenschaft und dem persönlichen Wachstum in Beziehungen befassen.',
  components_ressources_card_2_title: 'Liebesblog',
  components_ressources_card_2_text: 'Lesen Sie Einblicke und Reflexionen darüber, wie jedes Sternzeichen liebt, heilt und Verbindungen aufbaut. Von Synastrie bis hin zur Planetenromantik – unser Blog ist Ihr Leitfaden zur astrologischen Liebe.',
  components_ressources_link: 'Erfahren Sie mehr',
  components_notes_and_google_title_1: 'Romantische Astrologie',
  components_notes_and_google_title_2: 'Liebesgewohnheiten',
  components_notes_and_google_title_3: 'Liebesreflexionen der Zuhörer',
  components_review_google_text: 'Was unsere Zuhörer sagen',
  media_content_section_title: 'LIEBE & STERNZEICHEN-PODCAST',
  media_content_section_subheader_text: 'Real Talk über kosmische Romantik',
  text_media_1: 'Schalten Sie ein und erleben Sie tiefgründige, aufschlussreiche Episoden über astrologische Übereinstimmungen, emotionale Muster und romantische Dynamiken.',
  text_media_2: '',
  media_content_section_button_more: 'Jetzt anhören',
  text2_section_title: 'Ratgeber',
  text2_section_subheader_text: 'Astrologische Liebesgeschichten und Einblicke',
  text2_section_button_more: 'Mehr laden',
  components_text1_section_title: 'LEITFADEN',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Lassen Sie die Sterne Ihre Liebesgeschichte leiten',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registrierungsnummer',
  components_footer_legal: 'Rechtliches',
  components_footer_terms: 'Geschäftsbedingungen',
  components_footer_privacy: 'Datenschutzrichtlinie',
  button_load_more: 'Mehr laden',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Liebe & Sternzeichen: Podcast-Episoden',
  page_media_content_menu_compatibility: 'Kompatibilität',
  page_media_content_menu_love: 'Liebe',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Entdecken Sie die Liebe durch Astrologie',
  page_text2_section_title: 'Der Blog',
  page_text2_subheader_text: 'Artikel',
  enter_email_title: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren',
  enter_email_placeholder_email: 'E-Mail',
  enter_email_button_enter: 'Eingeben',
  components_login_success_text: 'Erfolgreich angemeldet!',
  components_card_link_media_content: 'Jetzt anhören',
  components_card_link_text2_content: 'Artikel lesen',
  components_card_link_text1_content: '',
  france: 'Frankreich',
  cyprus: 'Zypern',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditation',
  page_media_content_menu_all: 'Alle',
};